// Typed same-origin API client. Owner: integration lead (WP00). Never sends credentials anywhere but POST /api/connections bodies.
import { CSRF_HEADER, CSRF_VALUE, type ApiError, type ErrorCode } from '@tuned/contracts';

export class ApiRequestError extends Error {
  code: ErrorCode;
  status: number;
  retryable: boolean;
  requestId: string;
  details?: Record<string, unknown>;
  constructor(status: number, e: ApiError['error']) {
    super(e.message);
    this.code = e.code; this.status = status; this.retryable = e.retryable; this.requestId = e.requestId; this.details = e.details;
  }
}

type Method = 'GET' | 'POST' | 'PATCH' | 'DELETE';
export async function api<T>(method: Method, path: string, body?: unknown, init: { signal?: AbortSignal; keepalive?: boolean } = {}): Promise<T> {
  const headers: Record<string, string> = { accept: 'application/json' };
  if (method !== 'GET') headers[CSRF_HEADER] = CSRF_VALUE;
  if (body !== undefined) headers['content-type'] = 'application/json';
  const res = await fetch(path, { method, headers, body: body === undefined ? undefined : JSON.stringify(body), credentials: 'same-origin', ...init });
  if (res.status === 204) return undefined as T;
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const err = (data as ApiError | null)?.error ?? { code: 'INTERNAL', message: 'Unexpected response. Try again.', retryable: true, requestId: '' };
    throw new ApiRequestError(res.status, err as ApiError['error']);
  }
  return data as T;
}

export const qs = (params: Record<string, string | number | boolean | undefined | null>) => {
  const u = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== null && v !== '') u.set(k, String(v));
  const s = u.toString();
  return s ? `?${s}` : '';
};
